import React, { useState, useEffect } from 'react';

import { useReactToPrint } from 'react-to-print';

import api from '../../services/api';
import { useLocation } from 'react-router-dom';
import logo from '../../assets/logo.png';
import { useParams } from 'react-router-dom';
import './styles.css';
import { useRef } from 'react';
import { Button } from 'primereact/button';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import Tour from '../Tour';
import { useTour } from '@reactour/tour';
import { stepsAtaPdf } from '../Tour/steps';

// OBS!!! Essa pagina usa o styles.css do Ata e o react-to-pdf usa o do AtaPdf

function formatDate(dateInput) {
  if (!dateInput) return 'Data não informada';
  const date = new Date(dateInput?.$date || dateInput);
  if (isNaN(date.getTime())) return 'Data inválida';

  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  const formattedDate = new Intl.DateTimeFormat('pt-BR', options).format(date);
  return formattedDate;
}

function formattedDateToNumbers(dateInput) {
  if (!dateInput) return '';
  const date = new Date(dateInput?.$date || dateInput);
  if (isNaN(date.getTime())) return '';

  const options = { year: 'numeric', month: 'numeric', day: 'numeric' };
  const formattedDateToNumbers = new Intl.DateTimeFormat(
    'pt-BR',
    options,
  ).format(date);
  return formattedDateToNumbers;
}

function formatTime(timeInput) {
  if (!timeInput) return '--:--';
  const date = new Date(timeInput?.$date || timeInput);
  if (isNaN(date.getTime())) return '--:--';

  const options = { hour: 'numeric', minute: 'numeric' };
  const formattedTime = new Intl.DateTimeFormat('pt-BR', options).format(date);
  return formattedTime;
}

const SvgIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="20"
    viewBox="0 0 16 20"
    fill="none"
  >
    <path
      d="M10 0L16 6V18C16 18.5304 15.7893 19.0391 15.4142 19.4142C15.0391 19.7893 14.5304 20 14 20H2C1.46957 20 0.960859 19.7893 0.585786 19.4142C0.210714 19.0391 0 18.5304 0 18V2C0 1.46957 0.210714 0.960859 0.585786 0.585786C0.960859 0.210714 1.46957 0 2 0H10ZM14 18V7H9V2H2V18H14ZM8 17L4 13H6.5V10H9.5V13H12L8 17Z"
      fill="#3900DB"
    />
  </svg>
);

const style = {
  table: {
    borderCollapse: 'collapse',
    width: '50%',
    textAlign: 'left',
    marginTop: '20px',
    marginBottom: '20px',
  },
  th: {
    width: '50%',
    color: '#00293B',
    borderBottom: '1px solid #ddd',
    padding: '10px',
    fontSize: '18px',
    fontWeight: 'bold',
    backgroundColor: '#57575826',
  },
  td: {
    borderBottom: '1px solid #ddd',
    padding: '10px',
    fontSize: '16px',
  },
  tdEven: {
    //cor de fundo para linhas pares
    borderBottom: '1px solid #ddd',
    padding: '10px',
    fontSize: '16px',
    backgroundColor: 'rgba(228,228,231,0.2)',
  },
};

const Pdf = React.forwardRef((props, ref) => {
  const { ata, isDocument, customFields } = props;

  const ataString = ata
    ? isDocument
      ? `${ata?.title || 'Documento'}_${formattedDateToNumbers(
          ata?.date?.$date || ata?.date,
        )
          .split('/')
          .join('_')}`
      : `${ata?.cliente || 'Cliente'}_${ata?.projeto || 'Projeto'}_${formattedDateToNumbers(
          ata?.date?.$date || ata?.date,
        )
          .split('/')
          .join('_')}`
    : '';

  localStorage.setItem('ataString', ataString);
  // atualizar a pagina aqui

  localStorage.getItem('ataString');
  return (
    <div className="page" ref={ref}>
      <div className="print-logo-title">
        <img className="img-logo-fn" alt="logo" src={logo} />
        <p className="titulo-ata">{ataString}</p>
      </div>

      {!isDocument ? (
        <>
          <p className="titulo_wrapper">1.Informações básicas:</p>

          <div id="dados-info-basicas" className="subtitle">
            <div
              className="info-basicas"
              style={{ marginTop: '2%', display: 'flex', flexDirection: 'row' }}
            >
              <div className="data-field">
                <span style={{ color: '#00293B', fontWeight: 'bold' }}>
                  Data
                </span>
                <span style={{ color: '#00293B' }} className="smallsize">
                  {': ' + formatDate(ata.date?.$date || ata.date)}
                </span>
              </div>
              <div className="horario-field">
                <span className="tempo-inicial-titulo">Horário</span>
                <span style={{ color: '#00293B' }} className="smallsize">
                  {': ' +
                    formatTime(
                      ata.tempoInicial?.$date || ata.tempoInicial,
                    )}{' '}
                  - {formatTime(ata.tempoFinal?.$date || ata.tempoFinal)}
                </span>
              </div>

              <span className="tempo-final-titulo">Duração da reunião:</span>
              <span style={{ color: '#00293B' }} className="smallsize">
                {ata?.duracao} horas
              </span>
            </div>
            <div className="info-basicas">
              <div className="cliente-field">
                <span style={{ color: '#00293B', fontWeight: 'bold' }}>
                  Cliente
                </span>
                <span style={{ color: '#00293B' }} className="smallsize">
                  {': ' + ata.cliente}
                </span>
              </div>
              <div className="projeto-field">
                <span className="projeto-titulo">Projeto</span>
                <span style={{ color: '#00293B' }} className="smallsize">
                  {': ' + ata.projeto}
                </span>
              </div>
            </div>
          </div>

          <div className="smallsize">
            <div className="titulo_wrapper"> 2.Participantes:</div>

            <table className="table-participantes" style={style.table}>
              <thead>
                <tr>
                  <th style={style.th} className="subtitle">
                    Xerlock
                  </th>
                  <th style={style.th} className="subtitle">
                    Cliente
                  </th>
                </tr>
              </thead>
              <tbody>
                {(ata.participantesFN || [])
                  .concat(
                    (ata.participantesClientes || []).slice(
                      (ata.participantesFN || []).length,
                    ),
                  )
                  .map((participante, index) => (
                    <tr key={index}>
                      <td
                        style={index % 2 === 0 ? style.tdEven : style.td}
                        className="smallsizetable"
                      >
                        {ata.participantesFN && ata.participantesFN[index]
                          ? ata.participantesFN[index].emailFN
                          : ''}
                      </td>
                      <td
                        style={index % 2 === 0 ? style.tdEven : style.td}
                        className="smallsizetable"
                      >
                        {ata.participantesClientes &&
                        ata.participantesClientes[index]
                          ? ata.participantesClientes[index].emailCliente
                          : ''}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <div className="pagebreak">
            <p className="titulo_wrapper">3.Pontos abordados:</p>
            {(ata.pontosAbordados || []).map((pontos, index) => (
              <div
                className="bloco-wrapper"
                style={{ pageBreakInside: 'avoid' }}
                key={index}
              >
                <p
                  className="subtext pontos-discutidos espaco-topo"
                  style={{ fontSize: '20px' }}
                >
                  Item {index + 1}:
                </p>
                <div className="texto-placeholder smallsize">{pontos.item}</div>
                <span className="pontos-discutidos smallsize">
                  Pontos discutidos:
                </span>
                <ul className="texto-do-editor">
                  <li className="smallsize">• {pontos.editorValue}</li>
                </ul>
              </div>
            ))}
          </div>
          <div className="pagebreak" style={{ pageBreakInside: 'avoid' }}>
            <div className="titulo_wrapper">4.Decisões tomadas:</div>
            <table className="table-participantes" style={style.table}>
              <thead>
                <tr>
                  <th style={style.th} className="subtitle">
                    Decisão
                  </th>
                  <th style={style.th} className="subtitle">
                    Item Referente
                  </th>
                </tr>
              </thead>
              <tbody>
                {(ata.decisoesTomadas || []).map((decisao, index) => (
                  <tr key={index}>
                    <td
                      style={index % 2 === 0 ? style.tdEven : style.td}
                      className="smallsizetable"
                    >
                      {ata.decisoesTomadas && ata.decisoesTomadas[index]
                        ? ata.decisoesTomadas[index].decisoes
                        : ''}
                    </td>
                    <td
                      style={index % 2 === 0 ? style.tdEven : style.td}
                      className="smallsizetable"
                    >
                      {' '}
                      {/*deixando a cor de fundo diferente para linhas pares*/}
                      {ata.decisoesTomadas && ata.decisoesTomadas[index]
                        ? ata.decisoesTomadas[index].itemReferente
                        : ''}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div>
            <div className="titulo_wrapper pagebreak">5.Próximos passos:</div>

            {(ata?.proximosPassos || []).map(
              (proximoPasso, index) => (
                (
                  <div
                    key={index}
                    className="proximos-passos-div pagebreak"
                    style={{ pageBreakInside: 'avoid' }}
                  >
                    <div className="titulo_wrapper-proximos-passos">
                      <div
                        className="proximos-passos-atv "
                        style={{ color: '#00293B' }}
                      >
                        <span
                          className="subtext"
                          style={{ fontWeight: 'bold', fontSize: '21px' }}
                        >
                          Atividade{' '}
                        </span>
                        <span
                          className="subtext"
                          style={{ fontWeight: 'normal' }}
                        >
                          {' '}
                          {proximoPasso.atividade
                            ? ': ' +
                              proximoPasso.atividade.charAt(0).toUpperCase() +
                              proximoPasso.atividade.slice(1)
                            : ''}
                        </span>
                      </div>
                      <div
                        className="proximos-passos-responsavel "
                        style={{ color: '#00293B' }}
                      >
                        <span
                          style={{
                            fontWeight: 'bold',
                            marginLeft: '-50px',
                            fontSize: '21px',
                          }}
                          className="subtext"
                        >
                          Responsável{' '}
                        </span>
                        <span
                          style={{ fontWeight: 'normal' }}
                          className="subtitle"
                        >
                          {' '}
                          {proximoPasso.responsavel
                            ? ': ' + proximoPasso.responsavel
                            : ''}
                        </span>
                      </div>
                    </div>

                    <div className="proximos-passos-descricao">
                      <div
                        style={{
                          color: '#00293B',
                          fontSize: '18px',
                        }}
                        className="subtitle"
                      >
                        Descrição{' '}
                      </div>
                      <p
                        className="descricao-text subtitle"
                        style={{
                          display: 'block',
                          fontStyle: 'normal',
                          fontSize: '18px',
                        }}
                      >
                        • {proximoPasso.editorValue ?? ''}
                      </p>
                    </div>
                    <div
                      className="proximos-passos-prazo"
                      style={{ color: '#00293B', fontSize: '19px' }}
                    >
                      <div
                        style={{ fontWeight: 'bold', fontSize: '19px' }}
                        className="subtext"
                      >
                        Prazo
                        <span className="subtext-prazo">
                          {': ' +
                            formattedDateToNumbers(
                              proximoPasso.prazo?.$date || proximoPasso.prazo,
                            )}
                        </span>
                      </div>
                    </div>
                  </div>
                )
              ),
            )}
          </div>
        </>
      ) : (
        <>
          <p className="titulo_wrapper">Informações do Documento:</p>
          <div style={{ marginLeft: '5%', marginTop: '2%' }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                marginBottom: '10px',
              }}
            >
              <span
                style={{
                  color: '#00293B',
                  fontWeight: 'bold',
                  marginRight: '5px',
                }}
              >
                Título:
              </span>
              <span style={{ color: '#00293B' }} className="smallsize">
                {ata?.title || 'N/A'}
              </span>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                marginBottom: '10px',
              }}
            >
              <span
                style={{
                  color: '#00293B',
                  fontWeight: 'bold',
                  marginRight: '5px',
                }}
              >
                Data:
              </span>
              <span style={{ color: '#00293B' }} className="smallsize">
                {formatDate(ata?.date?.$date || ata?.date) || 'N/A'}
              </span>
            </div>
            {ata?.projeto?.nome && (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  marginBottom: '10px',
                }}
              >
                <span
                  style={{
                    color: '#00293B',
                    fontWeight: 'bold',
                    marginRight: '5px',
                  }}
                >
                  Projeto:
                </span>
                <span style={{ color: '#00293B' }} className="smallsize">
                  {ata.projeto.nome}
                </span>
              </div>
            )}
            {Object.keys(customFields).length > 0 && (
              <>
                <p
                  style={{
                    color: '#00293B',
                    fontWeight: 'bold',
                    marginTop: '20px',
                    marginBottom: '10px',
                  }}
                >
                  Campos Personalizados:
                </p>
                {Object.entries(customFields).map(([key, value]) => (
                  <div
                    key={key}
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      marginBottom: '5px',
                    }}
                  >
                    <span
                      style={{
                        color: '#00293B',
                        fontWeight: 'bold',
                        marginRight: '5px',
                        textTransform: 'capitalize',
                      }}
                    >
                      {key.replace(/_/g, ' ')}:
                    </span>
                    <span style={{ color: '#00293B' }} className="smallsize">
                      {value || 'N/A'}
                    </span>
                  </div>
                ))}
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
});

const AtaPdf = () => {
  const { setSteps } = useTour();

  const { ataId } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const docType = queryParams.get('type');

  const [ata, setAta] = useState(null);
  const [isDocument, setIsDocument] = useState(false);
  const [customFields, setCustomFields] = useState({});
  const history = useHistory();

  let token = localStorage.getItem('auth-token');

  const pdfRef = useRef();

  const handleCancel = () => {
    history.push(`/nova-ata/${ataId}`);
  };

  const handlePrint = useReactToPrint({
    content: () => pdfRef.current,
    documentTitle: ata
      ? `${ata?.cliente}_${ata?.projeto}_${formattedDateToNumbers(ata?.date)
          .split('/')
          .join('_')}`
      : isDocument
        ? `${ata?.title || 'Documento'}_${formattedDateToNumbers(
            ata?.date?.$date || ata?.date,
          )
            .split('/')
            .join('_')}`
        : '',
    onAfterPrint: () => {
      toast.info(
        <>
          <SvgIcon />
          {' Download realizado!'}
        </>,
        {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        },
      );
    },
  });

  useEffect(() => {
    handlePrint();
    setSteps(stepsAtaPdf);
  }, [handlePrint, setSteps]);
  useEffect(() => {
    const buscarAta = async () => {
      try {
        let response;
        let fromDocument = false;

        if (docType === 'documento') {
          response = await api.get(`/documentos/${ataId}`, {
            headers: {
              'X-Auth-Token': token,
              'content-type': 'application/json',
            },
          });
          fromDocument = true;
        } else {
          try {
            response = await api.get(`/api/ata/minhas/${ataId}`, {
              headers: {
                'X-Auth-Token': token,
                'content-type': 'application/json',
              },
            });
          } catch (error) {
            // Fallback para documentos se a rota da ata falhar
            response = await api.get(`/documentos/${ataId}`, {
              headers: {
                'X-Auth-Token': token,
                'content-type': 'application/json',
              },
            });
            fromDocument = true;
          }
        }

        setIsDocument(fromDocument);
        setAta(response.data);
        if (fromDocument) {
          setCustomFields(response.data.fields || {});
        }
      } catch (error) {
        console.error('Erro ao buscar ata:', error);
      }
    };

    if (ataId) {
      buscarAta();
    }
  }, [ataId, docType, token]);
  return ata ? (
    <div style={{ marginTop: '45px' }}>
      <br />
      <center>
        <Button
          label="Cancelar"
          className="p-button-outlined p-button-primary cancelar-pdf"
          style={{
            color: 'red',
            fontWeight: '600',
            backgroundColor: '#fff',
            marginTop: '12px',
            marginBottom: '20px',
            marginRight: '5px',
          }}
          onClick={handleCancel}
        />
        <Button
          label="Exportar como pdf"
          className="p-button-outlined p-button-primary download-pdf"
          style={{
            color: 'white',
            fontWeight: '600',
            backgroundColor: '#00293B',
            marginTop: '12px',
            marginBottom: '20px',
          }}
          onClick={handlePrint}
        />
        <div ref={pdfRef}>
          <Pdf
            ataId={ataId}
            ata={ata}
            isDocument={isDocument}
            customFields={customFields}
          />
        </div>
        <div style={{ marginTop: '-14rem' }}>
          <Tour></Tour>
        </div>
      </center>
      <br />
      <br />
    </div>
  ) : (
    <p>Carregando...</p>
  );
};

export default AtaPdf;
